import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { ASSETS } from "@/data/site";

export const PageHero = ({ label, title, subtitle, image, crumbs = [] }) => (
  <section className="relative overflow-hidden bg-brand-blue pt-[112px]">
    <div className="absolute inset-0">
      <img src={image || ASSETS.vanHero} alt="" className="h-full w-full object-cover opacity-30" />
      <div className="absolute inset-0 bg-gradient-to-t from-brand-blue via-brand-blue/85 to-brand-blue/60" />
    </div>
    <div className="relative mx-auto max-w-7xl px-5 py-20 md:py-28 lg:px-8">
      <motion.nav
        initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}
        className="flex flex-wrap items-center gap-1 text-sm text-slate-400"
      >
        <Link to="/" className="hover:text-white">Home</Link>
        {crumbs.map((c) => (
          <span key={c.label} className="flex items-center gap-1">
            <ChevronRight className="h-3.5 w-3.5" />
            {c.to ? <Link to={c.to} className="hover:text-white">{c.label}</Link> : <span className="text-slate-300">{c.label}</span>}
          </span>
        ))}
      </motion.nav>

      {label && (
        <motion.span
          initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.1 }}
          className="mt-8 inline-flex items-center gap-2 text-xs md:text-sm uppercase tracking-[0.2em] font-semibold text-brand-gold"
        >
          <span className="h-px w-8 bg-brand-gold" /> {label}
        </motion.span>
      )}

      <motion.h1
        initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.15 }}
        className="mt-5 max-w-4xl font-display text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-white text-balance"
      >
        {title}
      </motion.h1>

      {subtitle && (
        <motion.p
          initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.25 }}
          className="mt-5 max-w-2xl text-lg text-slate-300 leading-relaxed"
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  </section>
);
